<template>
  <div id="app">
    <Header class="headers"></Header>
    <router-view class="topss"/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  background: linear-gradient(135deg, #f8fafc 100%, rgba(35, 145, 255, 0.05) 100%);
}
.topss{
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue